import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'

const gridFiltersConfig: any = {
    TEAMFILTER: { prop: null, param: 'TEAMFILTER', url_param: true },
    USERFILTER: { prop: null, param: 'USERFILTER', url_param: true },
    NRBETRFILTER: { prop: null, param: 'NRBETRFILTER', url_param: true },
}

const initialState = {
    loadTOListStatus: 'idle',
    loadTOListError: undefined as any,
    loadTOListLastArgs: undefined as any,
    loadTOStatus: 'idle',
    loadTOError: undefined as any,
    saveTOStatus: 'idle',
    saveTOError: undefined as any,

    toList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadTOList = createAsyncThunk('toSlice/loadTOList', async ({ gridFilters, globalFilters, forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().toSlice.loadTOListLastArgs
    if (_.isEqual(lastArgs, { gridFilters, globalFilters }) && !forceReload) { return }

    let promises = []
    {
        const [url, params] = prepParams(`/api/ixweb/nuristo/?OBJRANGE_FILTER=globalFilters.objectFilter&TEAM_FILTER=${gridFilters.lookupValues.TEAMFILTER ? Object.values(gridFilters.lookupValues.TEAMFILTER).map((x:any)=>x.HDR_ID) : ''}&USER_FILTER=${gridFilters.lookupValues.USERFILTER ? Object.values(gridFilters.lookupValues.USERFILTER).map((x:any)=>x.HDR_ID) : ''}${gridFilters.values.NRBETRFILTER ? '&NRBETREFF_FILTER=' + gridFilters.values.NRBETRFILTER : ''}&TIMEFILTER=globalFilters.fromFilter`, globalFilters, gridFilters)
        promises.push(client.get(
            url,
            {
                params,
            }
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: { gridFilters, globalFilters }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOListStatus } = getState().toSlice
        return loadTOListStatus !== 'pending'
    }
})

export const loadTO = createAsyncThunk('toSlice/loadTO', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nuristo/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadTOStatus } = getState().toSlice
        return loadTOStatus !== 'pending'
    }
})

export const saveTO = createAsyncThunk('toSlice/saveTO', async ({ to }: any, { rejectWithValue }: any) => {
    let promises = []
    if (to?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nuristo/${ to?.HDR_ID }/`,
            prepareData(to),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nuristo/`,
            prepareData(to),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: value1,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveTOStatus } = getState().toSlice
        return saveTOStatus !== 'pending'
    }
})

const ToSlice = createSlice({
    name: 'toSlice',
    initialState,
    reducers: {
        resetloadTOListError: (state) => {
            state.loadTOListError = undefined
        },
        resetloadTO: (state) => {
            state.formItem = undefined
            state.loadTOError = undefined
        },
        resetloadTOError: (state) => {
            state.loadTOError = undefined
        },
        resetsaveTO: (state) => {
            state.formItem = undefined
            state.saveTOError = undefined
        },
        resetsaveTOError: (state) => {
            state.saveTOError = undefined
        },
        removeFromToListById: (state, action) => {
            state.toList = state.toList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromToListByIds: (state, action) => {
            state.toList = state.toList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.toList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadTOListStatus = 'preloaded'
            state.loadTOListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.toList = []
            state.loadTOListStatus = 'idle'
            state.loadTOListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadTOList.pending, (state) => {
            state.loadTOListStatus = 'pending'
            state.loadTOListError = undefined
        })
        builder.addCase(loadTOList.fulfilled, (state, action) => {
            state.loadTOListStatus = 'idle'

            if (!action.payload) { return }

            state.loadTOListLastArgs = action.payload.args

            {
                state.toList = action.payload.data

            }
        })
        builder.addCase(loadTOList.rejected, (state, action) => {
            state.loadTOListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOListError = action.error.message
            } else {
                state.loadTOListError = action.payload
            }
        })

        builder.addCase(loadTO.pending, (state) => {
            state.loadTOStatus = 'pending'
            state.loadTOError = undefined
        })
        builder.addCase(loadTO.fulfilled, (state, action) => {
            state.loadTOStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toList.push(newItem) }
                else { state.toList[i] = { ...state.toList[i], ...newItem } }
            }
        })
        builder.addCase(loadTO.rejected, (state, action) => {
            state.loadTOStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadTOError = action.error.message
            } else {
                state.loadTOError = action.payload
            }
        })

        builder.addCase(saveTO.pending, (state) => {
            state.saveTOStatus = 'pending'
            state.saveTOError = undefined
        })
        builder.addCase(saveTO.fulfilled, (state, action) => {
            state.saveTOStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.toList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.toList.push(newItem) }
                else { state.toList[i] = { ...state.toList[i], ...newItem } }
            }
        })
        builder.addCase(saveTO.rejected, (state, action) => {
            state.saveTOStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveTOError = action.error.message
            } else {
                state.saveTOError = action.payload
            }
        })

    }
})

export const {
    resetloadTOListError,
    resetloadTO,
    resetloadTOError,
    resetsaveTO,
    resetsaveTOError,
    removeFromToListById,
    removeFromToListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = ToSlice.actions
export default ToSlice.reducer
